import environment from '@lib/environment';
import { rewriteFramesIntegration } from '@sentry/integrations';
import * as Sentry from '@sentry/react';
import { useEffect } from 'react';
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from 'react-router-dom';

import appManager from '../../app/appManager';
import AppModule from '../../app/lib/AppModule';
import { sentryErrorIntegration } from '@modules/DiagnosticsModule';
import { AuthUser } from '@modules/AuthModule/lib/types';

export class SentryModule extends AppModule {
  override preload(): void {
    this.app.events.on('app.started', () => {
      if (environment.SENTRY_DSN) {
        Sentry.init({
          dsn: environment.SENTRY_DSN,
          environment: environment.RUNTIME_ENV,
          integrations: [
            Sentry.reactRouterV6BrowserTracingIntegration({
              useEffect,
              useLocation,
              useNavigationType,
              createRoutesFromChildren,
              matchRoutes,
            }),
            rewriteFramesIntegration(),
            sentryErrorIntegration,
          ],
          release: environment.APP_VERSION,
          tracesSampleRate: 1.0,
        });
        this.app.logger.info('initialized');
      }
    });

    this.app.events.on('auth.signin', (user: AuthUser) => {
      if (environment.SENTRY_DSN) {
        Sentry.setUser({
          id: user.id,
          username: user.name,
          ip_address: '{{auto}}',
        });
        Sentry.setContext('Org', {
          id: user.org.id,
          name: user.org.name,
          contactCenterId: user.contactCenterId,
          hasActiveContract: user.org.hasActiveContract,
          accountId: user.accountId,
        });
        this.app.logger.info('user identified: ', user.id);
      }
    });

    this.app.events.on('auth.signout', () => {
      if (environment.SENTRY_DSN) {
        Sentry.setUser(null);
      }
    });
  }
}

export default new SentryModule(appManager.events, appManager.logger('Sentry'));
